import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { queryOptionsGetWorkspace } from '../api/workspaces/workspaceApi';

export const useActiveWorkspace = () => {
  const { workspaceId } = useParams();
  const activeWorkspaceQuery = useQuery(queryOptionsGetWorkspace(workspaceId));

  return [activeWorkspaceQuery.data, activeWorkspaceQuery] as const;
};
